import React, { Suspense, lazy, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import SpinnerLoader from "../Utils/SpinnerLoader";
import axios from "axios";

const Header = lazy(() => import("../PostEvent/Header/index"));
const Banner = lazy(() => import("./Banner"));
const EventBody = lazy(() => import("./EventBody"));
const PostEvent = lazy(() => import("../PostEvent/PostHome"));
const NFT = lazy(() => import("./NFT"));

export default function AngelAiCustomPreEvent({
    themeId,
    eventType,
    eventCreatedUnderDomain,
    eventPageData,
    preEventData,
    isMobile,
    webpageData
}) {
    const [loading, setLoading] = useState(false);
    const [showOtherComponents, setShowOtherComponents] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const hashKey = searchParams.get("nft");
    const [guestData, setGuestData] = useState(null);
    const [validHashKey, setValidHashKey] = useState(false);
    // Shared carousel ref for Banner and BuyTicket communication
    const sharedCarouselRef = React.useRef(null);

    useEffect(() => {
        if (!isMobile) {
            setShowOtherComponents(true);
        } else {
            const handleScroll = () => {
                const windowHeight = window.innerHeight;
                const documentHeight = document.body.offsetHeight;
                const scrollPosition =
                    window.scrollY ||
                    window.pageYOffset ||
                    document.documentElement.scrollTop;
                const maxScroll = documentHeight - windowHeight;
                const percentage = (scrollPosition / maxScroll) * 100;

                if (percentage > 10) {
                    setShowOtherComponents(true);
                }
            };

            window.addEventListener("scroll", handleScroll);

            return () => {
                window.removeEventListener("scroll", handleScroll);
            };
        }
    }, [isMobile]);

    useEffect(() => {
        async function validateQRCode() {
            setLoading(true);
            if (!hashKey) {
                setLoading(false);
                return;
            }

            try {
                const res = await axios.post(
                    process.env.REACT_APP_VALIDATE_QR_CODE,
                    { key: hashKey }
                );

                if (res.data !== "Invalid QR Code") {
                    setGuestData(res.data);
                    setValidHashKey(true);
                }
            } catch (err) {

            }
            setLoading(false);
        }

        validateQRCode();
    }, [hashKey]);

    return (
        <>
            {loading ?
                <SpinnerLoader />
            :
                <Suspense fallback={<SpinnerLoader />}>
                    <Header
                        eventCreatedUnderDomain={eventCreatedUnderDomain}
                        customAngelAiEvent={true}
                        isMobile={isMobile}
                    />
                    {validHashKey && guestData && (
                        <Suspense fallback={<SpinnerLoader />}>
                            <NFT
                                themeId={themeId}
                                eventType={eventType}
                                eventCreatedUnderDomain={eventCreatedUnderDomain}
                                eventPageData={eventPageData}
                                isMobile={isMobile}
                                showOtherComponents={showOtherComponents}
                                hashKey={hashKey}
                                guestData={guestData}
                                webpageData={webpageData}
                            />
                        </Suspense>
                    )}
                    {!validHashKey && !guestData && (
                        <Suspense fallback={<SpinnerLoader />}>
                             <PostEvent 
                     webpageData={webpageData}
                     // preEventData={preEventData}
                     isMobile={isMobile}
                     validHashKey={validHashKey}
                     carouselRef={sharedCarouselRef}
                    />
                        </Suspense>
                    )}
                </Suspense>
            }
        </>
    );
}
